import { Calendar, Users, CreditCard, BarChart } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Calendar,
      title: t('features.smartScheduling'),
      description: t('features.smartSchedulingDescription')
    },
    {
      icon: Users,
      title: t('features.clientManagement'),
      description: t('features.clientManagementDescription')
    },
    {
      icon: CreditCard,
      title: t('features.securePayments'),
      description: t('features.securePaymentsDescription')
    },
    {
      icon: BarChart,
      title: t('features.businessInsights'),
      description: t('features.businessInsightsDescription')
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold">{t('features.title')}</h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <feature.icon className="w-12 h-12 text-gebeya-pink mb-4" />
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
